import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PosForm from "../pages/SingleEpos";
import Layout from "./Layout";
import UsersHandle from "../pages/UserHandler";

const AppRoute = () => {
  const truncatedUserName = "DefaultUser"; 

  return (
    <Routes>
      <Route
        path="/"
        element={<Layout truncatedUserName={truncatedUserName} />}
      />
      <Route
        path="/tdr/user/handler"
        element={<UsersHandle />}
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoute;
